import React from 'react';
import PropTypes from 'prop-types';
import { VF_INPUT } from 'AppSrc/core/components/forms/form-base-components/v-f-input';
import { FormSection } from 'AppSrc/core/components/forms/form-section';
import {
  modalDisplayDataShape,
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
// Key values that are repeated a lot
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import { modalOptionsShape } from 'AppSrc/core/components/forms/modal-options';
// form fields
import { actualStartDate } from './actual-start-date';
import { actualEndDate } from './actual-end-date';

// Title for the modal
const sectionTitle = 'Actual CI Unavailability Window';

const selectedNetwork = 'mobile';
// callback for the form section to figure out what fields to render with conditional logic
const getCurrentFields = () => {
  const currentFields = [
    {
      ...defaultFieldLogic,
      componentData: {
        ...actualStartDate,
        vFParams: {
          ...actualStartDate.vFParams,
          selectedNetwork,
        },
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...actualEndDate,
        vFParams: {
          ...actualEndDate.vFParams,
          selectedNetwork,
        },
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        id: 'status',
        vFParams: {
          fieldTitle: '',
        },
        initialValues: '',
        fieldType: VF_INPUT,
      },
      shouldRender: false,
      shouldValidate: false,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        id: 'name',
        vFParams: {
          fieldTitle: '',
        },
        initialValues: '',
        fieldType: VF_INPUT,
      },
      shouldRender: false,
      shouldValidate: false,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        id: 'reference_id',
        vFParams: {
          fieldTitle: '',
        },
        initialValues: '',
        fieldType: VF_INPUT,
      },
      shouldRender: false,
      shouldValidate: false,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        id: 'ua_scheduled_start_date',
        vFParams: {
          fieldTitle: '',
        },
        initialValues: '',
        fieldType: VF_INPUT,
      },
      shouldRender: false,
      shouldValidate: false,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        id: 'ua_scheduled_end_date',
        vFParams: {
          fieldTitle: '',
        },
        initialValues: '',
        fieldType: VF_INPUT,
      },
      shouldRender: false,
      shouldValidate: false,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        id: 'ua_type',
        vFParams: {
          fieldTitle: '',
        },
        initialValues: '',
        fieldType: VF_INPUT,
      },
      shouldRender: false,
      shouldValidate: false,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        id: 'type',
        vFParams: {
          fieldTitle: '',
        },
        initialValues: '',
        fieldType: VF_INPUT,
      },
      shouldRender: false,
      shouldValidate: false,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        id: 'reference_type',
        vFParams: {
          fieldTitle: '',
        },
        initialValues: '',
        fieldType: VF_INPUT,
      },
      shouldRender: false,
      shouldValidate: false,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        id: 'id',
        vFParams: {
          fieldTitle: '',
        },
        initialValues: '',
        fieldType: VF_INPUT,
      },
      shouldRender: false,
      shouldValidate: false,
    },
  ];

  return currentFields;
};


// generates the formSection!
const CiUnavailabilityModal = React.memo(({
  handleSuccessfulSubmit,
  formData,
  outerFormData,
  modalOptions,
  modalDisplayData,
  editingStatus,
}) => (
  <FormSection
    sectionTitle={sectionTitle}
    sectionId={modalDisplayData.sectionId}
    getCurrentFields={getCurrentFields}
    formData={formData}
    outerFormData={outerFormData}
    modalOptions={modalOptions}
    handleSuccessfulSubmit={handleSuccessfulSubmit}
    editingStatus={editingStatus}
  />
));


CiUnavailabilityModal.propTypes = {
  handleSuccessfulSubmit: PropTypes.func,
  modalDisplayData: modalDisplayDataShape,
  // userRoles: userRolesPropShape,
  formData: formDataShape,
  outerFormData: formDataShape,
  modalOptions: modalOptionsShape,
  editingStatus: PropTypes.string,
};

const CI_UNAVAILABILITY_MODAL = 'CI_UNAVAILABILITY_MODAL';

export {
  getCurrentFields,
  CiUnavailabilityModal,
  CI_UNAVAILABILITY_MODAL,
};
